import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PaginatedDeliveryResponse } from '../models/delivery.model';
import {CargGroup} from "../models/carg.model";

@Injectable({
  providedIn: 'root'
})
export class DeliveryService {
  private apiUrl = `${environment.apiUrl}/scheduled/deliveries/`;

  constructor(private http: HttpClient) {}

  getDeliveries(filters: any = {}): Observable<PaginatedDeliveryResponse> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      let formattedValue = value;

      if (value instanceof Date) {
        // Format date in local time, not UTC
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');
        formattedValue = `${year}-${month}-${day}`;
      }

     if(this.isCargGroup(value)) {
         formattedValue = value.group_identifier
     }

      params = params.set(key, String(formattedValue));
    }
  });

   return this.http.get<PaginatedDeliveryResponse>(this.apiUrl, { params });
  }

  createDelivery(delivery: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, delivery);
  }

  updateDelivery(delivery: any) : Observable<any>{
    return this.http.put<any>(this.apiUrl,delivery);
  }

   isCargGroup(v: any): v is CargGroup {
    return (
        v != null &&
        typeof v === 'object' &&
        'group_identifier' in v &&
        'id' in v && 'group_name' in v
    );
  }



}
